import { render, staticRenderFns } from "./GiftCardLandingPage.vue?vue&type=template&id=42ee643a&scoped=true"
import script from "./GiftCardLandingPage.vue?vue&type=script&lang=js"
export * from "./GiftCardLandingPage.vue?vue&type=script&lang=js"
import style0 from "./GiftCardLandingPage.vue?vue&type=style&index=0&id=42ee643a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ee643a",
  null
  
)

export default component.exports